
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./ServicesPricingPage.css";
import EditPricingModal from "./EditPricingModal/EditPricingModal";
import { getAdditionalServicesByServiceIdAPI, updateAdditionalServiceAPI } from "../../../utils/APIs/servicesApis";
import Loader from "../../../Loader/Loader";


const staticFeatures = [
    "1–1.5 hours photoshoot",
    "Cake cutting and family moments",
    "Professionally edited digital photos",
    "High-resolution online delivery",
];
 // Define the desired order for pricing plans
    const planOrder = { 'basic': 1, 'standard': 2, 'premium': 3 };
    
const ServicesPricingPage = () => {
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editablePlan, setEditablePlan] = useState(null);
    const [additionalServices, setAdditionalServices] = useState([]);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const { serviceId } = useParams()
    console.log("SERVICE ID", serviceId)

    const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
        const stored = sessionStorage.getItem("isSidebarOpen");
        return stored !== null ? JSON.parse(stored) : true;
    });

    useEffect(() => {
        const interval = setInterval(() => {
            const stored = sessionStorage.getItem("isSidebarOpen");
            const parsed = stored !== null ? JSON.parse(stored) : true;

            if (parsed !== isSidebarOpen) {
                setIsSidebarOpen(parsed);
            }
        }, 10);

        return () => clearInterval(interval);
    }, [isSidebarOpen]);

    useEffect(() => {
        if (!serviceId) return;

        const fetchAdditionalServices = async () => {
            try {
                setLoading(true);
                const res = await getAdditionalServicesByServiceIdAPI(serviceId);

                // IMPORTANT: API returns array in res.data.data
                setAdditionalServices(res.data.data || []);
            } catch (error) {
                console.error("Failed to fetch additional services", error);
            } finally {
                setLoading(false);
            }
        };

        fetchAdditionalServices();
    }, [serviceId]);


    const handleEditClick = (plan) => {
        setEditablePlan({
            ...plan,
            price: plan.amount.toString(), // Store raw number for editing
            features: [...plan.features],
        });
        setIsEditModalOpen(true);
    };
    const handleEditChange = (e) => {
        const { name, value } = e.target;
        setEditablePlan((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleFeatureChange = (index, value) => {
        setEditablePlan((prev) => {
            let updatedFeatures = [...prev.features];

            // Add new feature
            if (index === "add") {
                updatedFeatures.push("");
            }
            // Remove feature
            else if (value === null) {
                updatedFeatures.splice(index, 1);
            }
            // Edit feature
            else {
                updatedFeatures[index] = value;
            }

            return {
                ...prev,
                features: updatedFeatures,
            };
        });
    };


    const handleSaveEdit = async () => {
        if (!editablePlan) return;

        try {
            setLoading(true);

            // Use the edited price string and title from the modal
            const updatedCost = editablePlan.price.toString().replace(/,/g, "");

            const payload = {
                serviceType: editablePlan.title.toLowerCase(),
                serviceCost: updatedCost,
                description: editablePlan.features,
            };

            await updateAdditionalServiceAPI(
                editablePlan.additionalServiceId,
                payload
            );

            // 🔄 Update UI without refetch (optimistic update)
            setAdditionalServices((prev) =>
                prev.map((item) =>
                    item._id === editablePlan.additionalServiceId
                        ? {
                            ...item,
                            serviceType: editablePlan.title.toLowerCase(),
                            serviceCost: updatedCost,
                            description: editablePlan.features,
                        }
                        : item
                )
            );

            setIsEditModalOpen(false);
        } catch (error) {
            console.error("Failed to update pricing", error);
        } finally {
            setLoading(false);
        }
    };







    const pricingPlans = React.useMemo(() => {
        return additionalServices
            .map((item) => ({
                title: item.serviceType.toUpperCase(),
                features:
                    item.description && item.description.length > 0
                        ? item.description
                        : staticFeatures,
                price: `₹${item.serviceCost}/-`,
                amount: Number(item.serviceCost.replace(/,/g, "")),
                isPopular: item.serviceType.toLowerCase() === "standard",
                mainServiceId: item.serviceId,
                additionalServiceId: item._id,
                sortOrder: planOrder[item.serviceType.toLowerCase()] || 999,
            }))
            .sort((a, b) => a.sortOrder - b.sortOrder);
    }, [additionalServices]); // ✅ now valid



    if (loading) {
        return <Loader />
    }


    return (
        <div
            className={`content-container ${isSidebarOpen ? "sidebar-open" : "sidebar-closed"
                }`}
            style={{ marginTop: "100px" }}
        >
            <div className="page-inner-wrapper">
                <button className="admin-back-btn" onClick={() => navigate(-1)}>
                    ← Back
                </button>
                {/* <h1 className="pricing-main-title page-title">Pricing</h1> */}

                <h1 className="page-title">{`${additionalServices?.[0]?.serviceName} Pricing`}</h1>


                <div className="pricing-container">
                    {pricingPlans.map((plan, index) => (
                        <div key={index} className="pricing-card">
                            {/* {plan.isPopular && (
              <div className="popular-badge">Recommended</div>
            )} */}

                            <h3 className="plan-title">{plan.title}</h3>



                            <ul className="plan-features">
                                {plan.features.map((feature, i) => (
                                    <li key={i}>{feature}</li>
                                ))}
                            </ul>

                            <button
                                className="price-btn-label"
                            // onClick={() => handleNavigate(plan)}
                            >
                                {plan.price}
                            </button>

                            <button
                                className="price-btn mt-4"
                                onClick={() => handleEditClick(plan)}
                                title="Edit Booking"
                            >
                                {/* <FiEdit size={16} />  */}
                                Edit
                            </button>

                        </div>

                    ))}
                </div>
                <EditPricingModal
                    isOpen={isEditModalOpen}
                    onClose={() => setIsEditModalOpen(false)}
                    editablePlan={editablePlan}
                    onChange={handleEditChange}
                    onFeatureChange={handleFeatureChange}
                    onSave={handleSaveEdit}
                />

            </div>
        </div>
    );
};

export default ServicesPricingPage;
